export default __webpack_public_path__ + "static/media/icon-frame-top10.004cc819.svg";